import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  approvedCount: 0,
  inProgressCount: 0,
  rejectedCount: 0,
  pendingCount: 0,
  repliedCount: 0,
  autoCloseCount: 0,
  entities: [],
  itemDeleted: {},
  issueCategoryForEdit: {},
  companyDetails: {},
  ticketForEdit: {},
  lastError: null,
  callRequestCount: 0
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const userProfileCrm = createSlice({

  name: "userProfileCrm",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // singleItemFetched
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.issueCategoryForEdit = action.payload.issueCategoryForEdit;
      state.error = null;
    },

    companyDetails: (state, action) => {
      console.log('action', action.payload)
      state.actionsLoading = false;
      state.companyDetails = action.payload.companyDetails;
      state.error = null;
    },
    // listFetched
    listFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // itemCreated
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities = [];
      // state.entities.push(action.payload.item);
    },
    // itemUpdated
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.item._id) {
      //     return action.payload.item;
      //   }
      //   return entity;
      // });
    },
    // itemDeleted
    itemDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.filter(el => el.id !== action.payload.id);
      state.itemDeleted = action.payload;

    },
    // itemsDeleted
    itemsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // itemStatusUpdated
    itemStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    // listFetched
    ticketListFetched: (state, action) => {
      const { totalCount, entities, approvedCount, inProgressCount, rejectedCount, pendingCount, repliedCount, autoCloseCount, callRequestCount } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.approvedCount = approvedCount;
      state.inProgressCount = inProgressCount;
      state.rejectedCount = rejectedCount;
      state.pendingCount = pendingCount;
      state.repliedCount = repliedCount;
      state.autoCloseCount = autoCloseCount;
      state.callRequestCount = callRequestCount;
    },


    callRequestListFetched: (state, action) => {
      const { callRequestCount, entities,totalCount } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.callRequestCount = callRequestCount;
    
    },

    // singleItemFetched
    singleTicketFetched: (state, action) => {
      state.actionsLoading = false;
      state.ticketForEdit = action.payload.ticketForEdit;
      state.error = null;
    },
  }
});
